import { useTranslation } from 'react-i18next';

import { StatusPageActions } from './StatusPageActions';
import HsStatusPage from 'src/components/common/hs/HsStatusPage';
import useDocumentTitle from 'src/hooks/common/document-title';
import AppConstant from 'src/utils/constants';

/** 권한이 없는 화면(API가 403을 주면 use-api가 `/forbidden`으로 보낸다) */
export default function ForbiddenPage() {
  const { t } = useTranslation();
  useDocumentTitle('403');

  // 막힌 화면이 아니라 그 앞 화면으로 돌아오게 한다(바로 들어왔으면 서비스 첫 화면)
  const back = document.referrer.startsWith(window.location.origin) ? document.referrer : window.location.origin;

  return (
    <HsStatusPage code="403" title={t('hs.forbidden-title')} description={t('hs.forbidden-desc')}>
      <StatusPageActions />
      <a className="hs-btn ghost" href={`${AppConstant.AUTH_LOGIN}?url=${encodeURIComponent(back)}`}>
        {t('hs.switch-account')}
      </a>
    </HsStatusPage>
  );
}
